/**
 *    Image
 *
 *    @tableofcontent
 *      1. Dependencies
 *      2. Functions
 *       2.1 Init
 *       2.2 Image
 *
 */


/**
 *     @section 1. Dependencies
 */

import Constants from '../settings/_variables';


/**
 *     @section 2. Functions
 */

export default {

    // @section 2.1 Init
    init() {
        // console.log('image loaded ...');

        this.image();
    },

    // @section 2.2 Image
    image() {
        $('img').on('load', function() {
            $(this).parents('figure').addClass(`${Constants.prefix}--loaded`);
        }).each(function() {
            if(this.complete) {
                $(this).trigger('load');
            }
        });
    }
};

// end of _image.js
